/*
add dynamic booking-element
use: <cfn-booking-element type="{{ele.fileName || ele.name}}"></cfn-booking-element>
add templates to routes.js or in bookingRulesGen.js!
*/

angular.module('cfn').directive('cfnBookingElement', [
  '$rootScope',
  '$log',
  '$compile',
  function($rootScope, $log, $compile) {
    return {
      restrict: 'E',
      link: function(scope, element, attrs) {
        var directive = 'cfn-booking-' + attrs['type'].toLowerCase();
        var template =
          '<' + directive + " class='clearfix'></" + directive + '>';
        element.append($compile(template)(scope));
      }
    };
  }
]);
